export default __webpack_public_path__ + "static/media/register_root_background.c91566f4.jpg";